import { render } from "./ProfileSecurityTab.vue?vue&type=template&id=92b4e0c0&scoped=true&ts=true"
import script from "./ProfileSecurityTab.vue?vue&type=script&lang=ts"
export * from "./ProfileSecurityTab.vue?vue&type=script&lang=ts"

import "./ProfileSecurityTab.vue?vue&type=style&index=0&id=92b4e0c0&scoped=true&lang=scss"

import exportComponent from "/home/nathan/public_html/accident-plan/accident-plan-api-whitelabel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-92b4e0c0"]])

export default __exports__